import { useOrders } from './hooks/useOrders'
import OrdersIndex from './components/OrdersIndex'
import OrderDetail from './components/OrderDetail'
import { EcommerceProductTypeEnum } from 'generated/api'

function Orders() {
  const useOrdersHook = useOrders(EcommerceProductTypeEnum.Goods)

  const loading = useOrdersHook.statusFetch === 'loading'
  const failed = useOrdersHook.statusFetch === 'failed'
  const loadingModal = useOrdersHook.statusFetchModal === 'loading'

  return (
    <div className="content-wrapper">
      {useOrdersHook.toastContainer}
      {!useOrdersHook.selectedOrder ? (
        <OrdersIndex
          isLoading={loading}
          isFailed={failed}
          orders={useOrdersHook.orders}
          tableType={EcommerceProductTypeEnum.Goods}
          totalRows={useOrdersHook.totalRows}
          currentLimit={useOrdersHook.limit}
          currentPage={useOrdersHook.page}
          inputSearch={useOrdersHook.searchKeyword}
          selectedStatus={useOrdersHook.status}
          sortDirection={useOrdersHook.sortDirection}
          sortField={useOrdersHook.sortField}
          onChangeInputSearch={useOrdersHook.changeSearchKeywordOrders}
          onChangeSelectedStatus={useOrdersHook.changeStatusOrders}
          onSearchOrder={useOrdersHook.enterSearchKeywordOrders}
          onFetchOrder={useOrdersHook.fetchOrders}
          onSelectOrder={useOrdersHook.selectOrder}
          onChangeSort={useOrdersHook.changeSortOrders}
          onChangeCurrentPage={useOrdersHook.changePageOrders}
          onChangeCurrentLimit={useOrdersHook.changeLimitPageOrders}
        />
      ) : (
        <OrderDetail
          isLoading={loading}
          isLoadingModal={loadingModal}
          isShowConfirmPopup={useOrdersHook.isShowConfirmPopup}
          isShowChangePickUpPopup={useOrdersHook.isShowChangePickUpPopup}
          selectedOrder={useOrdersHook.selectedOrder}
          selectedPaymentDetail={useOrdersHook.selectedOrderPaymentDetail}
          selectedDeliveryDetail={useOrdersHook.selectedOrderDeliveryDetail}
          selectedRecipientDetail={useOrdersHook.selectedOrderRecipientDetail}
          onSelectedOrder={useOrdersHook.selectOrder}
          isOrderAllowedChangePickup={useOrdersHook.isOrderAllowedChangePickup}
          openConfirmOrderModal={useOrdersHook.openConfirmModal}
          openChangePickUpModal={useOrdersHook.openChangePickUpModal}
          cancelConfirmOrderModal={useOrdersHook.cancelConfirmModal}
          cancelChangePickUpModal={useOrdersHook.cancelChangePickUpModal}
          acceptConfirmOrderModal={useOrdersHook.acceptConfirmOrderModal}
          acceptChangePickUpModal={useOrdersHook.acceptChangePickUpModal}
        />
      )}
    </div>
  )
}

export default Orders
